module.exports = __webpack_public_path__ + "static/media/synapse-logo.d377794d.svg";